import { initContract } from "@ts-rest/core";

import { applicationsContract } from "./applicationsContract";
import { auditTrailsContract } from "./auditTrailsContract";
import { authContract } from "./authContract";
import { brokersContract } from "./brokersContract";
import { cesSurveysContract } from "./cesSurveysContract";
import { consentDocumentsContract } from "./consentDocumentsContract.ts";
import { consentsContract } from "./consentsContract";
import { coverageContract } from "./coverageContract.ts";
import { eligibilityCategoriesContract } from "./eligibilityCategoriesContract";
import { eligibilityResultsContract } from "./eligibilityResultsContract";
import { fplConstantsContract } from "./fplConstantsContract";
import { healthPlansContract } from "./healthPlansContract";
import { householdMemberRelationshipsContract } from "./householdMemberRelationshipsContract";
import { householdMembersContract } from "./householdMembersContract";
import { householdsContract } from "./householdsContract.ts";
import { npsSurveysContract } from "./npsSurveysContract";
import { patientsContract } from "./patientsContract";
import { patientsShortCodesContract } from "./patientShortCodesContract";
import { redeterminationsContract } from "./redeterminationsContract";
import { uploadedDocumentsContract } from "./uploadedDocumentsContract";
import { verifyApiContract } from "./verifyApiContract";
import { workRequirementsContract } from "./workRequirementsContract";

const c = initContract();

export const patientsApiContract = c.router(
  {
    patients: patientsContract,
    auth: authContract,
    householdMembers: householdMembersContract,
    householdMemberRelationships: householdMemberRelationshipsContract,
    uploadedDocuments: uploadedDocumentsContract,
    consentDocuments: consentDocumentsContract,
    applications: applicationsContract,
    npsSurveys: npsSurveysContract,
    cesSurveys: cesSurveysContract,
    consents: consentsContract,
    coverage: coverageContract,
    fplConstants: fplConstantsContract,
    eligibilityCategories: eligibilityCategoriesContract,
    healthPlans: healthPlansContract,
    households: householdsContract,
    eligibilityResults: eligibilityResultsContract,
    verifyApi: verifyApiContract,
    redeterminations: redeterminationsContract,
    patientsShortCodes: patientsShortCodesContract,
    auditTrails: auditTrailsContract,
    brokers: brokersContract,
    workRequirements: workRequirementsContract,
  },
  {
    pathPrefix: "/api/patients",
  },
);

export * from "./types";
export * from "./schemas";
export type {
  UpdateWorkRequirementScreeningBodyType,
  WorkRequirementDetailType,
  WorkRequirementMemberDetailType,
  WorkRequirementSlotType,
} from "./workRequirementsContract";
